<template>

	<transition name="fade">

		<div class="overlay" v-if="overlay.show">

			<slot></slot>

		</div>

	</transition>

</template>

<script>
    export default {
        name: "modal",
		data(){
            return {
                overlay:{
                    show:false,
				}
			}
		},
		watch:{
          value(value){
              this.overlay.show = value;

              if(value){
                  document.body.classList.add('no-scroll');
			  }else{
                  if(document.body.classList.contains('no-scroll')){
                      document.body.classList.remove('no-scroll');
				  }
			  }
		  }
		},
		methods:{
			hide(){
			  this.overlay.show = false;
			  this.$emit('input', false);
			},
		},
		props:['value'],
    }
</script>

<style scoped>

</style>
